export default __webpack_public_path__ + "static/media/responsiveAffiliatesMainBanner.36e8a753.png";